function checkout() {
    const checkoutBtn = document.querySelectorAll(
        'button[name="checkout"], #checkout, .checkout-btn, .bss-checkout'
    );

    if (checkoutBtn.length) {
        checkoutBtn.forEach(element => {
            element.addEventListener("click", (e) => {
                if (checkoutBtn.disabled) {
                    e.preventDefault();
                    return false;
                }

                checkoutBtn.disabled = true;
                checkoutBtn.style.opacity = "0.6";
                checkoutBtn.style.cursor = "not-allowed";
                checkoutBtn.classList.add("bss-disable");

                setTimeout(() => {
                    checkoutBtn.disabled = false;
                    checkoutBtn.style.opacity = "1";
                    checkoutBtn.style.cursor = "pointer";
                    checkoutBtn.style.pointerEvents = "auto";
                    checkoutBtn.classList.remove("bss-disable");
                }, 3000);
            });
        });

    }
}

document.addEventListener("DOMContentLoaded", function() {

    let quickAddDrawer = document.querySelector(".cart-item");
    if (quickAddDrawer) {
        let observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(m) {
                if (m.addedNodes.length) {
                    console.log("Cart changed!");
                }
            });
        });

        observer.observe(quickAddDrawer, {
            childList: true,
        });
    }

    checkout();

    
    let a = document.querySelectorAll('[bss-b2b-btn-quickview]')
 if (a.length) {
     a.forEach(element => {
         element.addEventListener('click', () => {
             const bss = setInterval(() => {
                let a = document.querySelector('.detail.product-column-right')
                 if (a) {
                      document.dispatchEvent(new Event(`bss_b2b:QuickviewLoaded`))
                     clearInterval(bss)
                 }

             }, 100)
             setTimeout(() => {
                 clearInterval(bss)
             }, 3000)
         })
     });
 }

  const isPDP = window.location.pathname.includes("/products/");
if(isPDP) {
  let oldHref = location.href;
new MutationObserver(() => {
  if (oldHref !== location.href) {
    oldHref = location.href;
    const variant = new URL(location.href).searchParams.get('variant');
    setTimeout(() => {
      
      const productForm = document.querySelector("[bss-b2b-main-product-form]");
       BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {productForm});
    }, 600)
  }
}).observe(document, {subtree: true, childList: true});
} 

});